// ฟังก์ชันสำหรับคำนวณขนาดรูปภาพ
export function calculateImageSize(pngDims) {
  let imgWidth, imgHeight;

  // ตรวจสอบว่า ถ้าขนาดความกว้างของรูปภาพมากกว่าความสูง
  if (pngDims.width > pngDims.height) {
    // กำหนดความสูงให้ไม่เกิน 20px และปรับขนาดความกว้างตามสัดส่วนเดิม
    imgHeight = 30;
    imgWidth = (pngDims.width * imgHeight) / pngDims.height;
  } else {
    // กำหนดความกว้างให้ไม่เกิน 100px และปรับขนาดความสูงตามสัดส่วนเดิม
    imgWidth = 100;
    imgHeight = (pngDims.height * imgWidth) / pngDims.width;

    if (imgHeight > 30) {
      imgHeight = 30;
      imgWidth = (pngDims.width * imgHeight) / pngDims.height;
    }
  }

  return { width: imgWidth, height: imgHeight };
}

// ฟังก์ชันสำหรับวาดรูปภาพบน PDF โดยคงสัดส่วนเดิมไว้เมื่อความกว้างเกิน space
export async function drawImageOnPdf(image, page, startX, startY) {
  // ปรับขนาดรูปภาพ
  const pngDims = image.scale(0.3);
  let { width: imgW, height: imgH } = calculateImageSize(pngDims);

  // พิกัดที่ต้องการวาดรูปภาพบน PDF
  const space = 467 - startX;

  // ตรวจสอบว่าความกว้างของรูปภาพเกินพื้นที่หรือไม่
  if (imgW > space) {
    // ปรับความกว้างให้เท่ากับพื้นที่และปรับความสูงตามสัดส่วนเดิม
    imgW = space - 20;
    imgH = (pngDims.height * imgW) / pngDims.width;
  }

  const rest = space - imgW;
  const restHalf = Math.round(rest / 2);

  // วาดรูปภาพบนหน้า PDF
  page.drawImage(image, {
    x: startX + restHalf,
    y: startY,
    width: imgW,
    height: imgH,
  });
}
